var _excluded = ["implement", "scroll", "footer", "footerClassName", "footerStyle", "bodyClassName", "bodyStyle", "rowClassName", "onRow", "onHead", "renderEmpty", "emptyText", "rowKey", "datasource", "dataPropsMapping", "data", "columns", "rowExpandTrigger", "renderExpand", "renderExpandHeight", "expandedRowKeys", "onExpandedRowChange", "expandOptions", "treeOptions", "rowSelection", "selectOptions", "filters", "sorter", "multipleSorter", "pager", "onChange", "onStateChange", "internalProcess", "filterOptions", "sortOptions", "paginationOptions", "paginationProps", "columnsOptions"],
    _excluded2 = ["expansion"],
    _excluded3 = ["page", "defaultPage", "pageSize", "total"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo, useRef } from 'react';
import { isBoolean, isFunction, isObject } from '@okee-uikit/react-utils';
import { useConstCallback, useRefCallback } from '@okee-uikit/react-hooks';
import { useCEP } from '@okee-uikit/react-config';
import { useTableRowsInit, useTableRowsPostInit } from './row-data/row-info';
import { useTableColumnsInit } from './col-query/column-info';
import { useTableExpansionInit, useTableTreeInit } from './row-data/active';
import { useTableSelectionInit } from './row-data/selection';
import { useTableFilterInit } from './col-query/filter';
import { useTableSortInit } from './col-query/sort';
import { useTablePaginationInit } from './col-query/pagination';
import { TableContextProvider } from './context';
import { CepContext, ImplementContext, IMPLEMENT_DIV, IMPLEMENT_TABLE } from './implements/implement';
import { TableRoot } from './atom/root';
import { Summary } from './summary';
export function TableNew(props) {
  var _props$implement = props.implement,
      implement = _props$implement === void 0 ? 'table' : _props$implement,
      scroll = props.scroll,
      footer = props.footer,
      footerClassName = props.footerClassName,
      footerStyle = props.footerStyle,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      rowClassName = props.rowClassName,
      onRow = props.onRow,
      onHead = props.onHead,
      renderEmpty = props.renderEmpty,
      emptyText = props.emptyText,
      rowKey = props.rowKey,
      datasource = props.datasource,
      _props$dataPropsMappi = props.dataPropsMapping,
      dataPropsMapping = _props$dataPropsMappi === void 0 ? {} : _props$dataPropsMappi,
      _props$data = props.data,
      data = _props$data === void 0 ? datasource !== null && datasource !== void 0 ? datasource : [] : _props$data,
      propColumns = props.columns,
      rowExpandTrigger = props.rowExpandTrigger,
      renderExpand = props.renderExpand,
      renderExpandHeight = props.renderExpandHeight,
      expandedRowKeys = props.expandedRowKeys,
      onExpandedRowChange = props.onExpandedRowChange,
      propExpandOptions = props.expandOptions,
      propTreeOptions = props.treeOptions,
      rowSelection = props.rowSelection,
      propSelectOptions = props.selectOptions,
      filters = props.filters,
      sorter = props.sorter,
      _props$multipleSorter = props.multipleSorter,
      multipleSorter = _props$multipleSorter === void 0 ? false : _props$multipleSorter,
      _props$pager = props.pager,
      pager = _props$pager === void 0 ? false : _props$pager,
      propOnChange = props.onChange,
      propOnStateChange = props.onStateChange,
      _props$internalProces = props.internalProcess,
      internalProcess = _props$internalProces === void 0 ? false : _props$internalProces,
      _props$filterOptions = props.filterOptions,
      propFilterOptions = _props$filterOptions === void 0 ? false : _props$filterOptions,
      _props$sortOptions = props.sortOptions,
      propSortOptions = _props$sortOptions === void 0 ? false : _props$sortOptions,
      _props$paginationOpti = props.paginationOptions,
      propPaginationOptions = _props$paginationOpti === void 0 ? false : _props$paginationOpti,
      propPaginationProps = props.paginationProps,
      propColumnsOptions = props.columnsOptions,
      attrs = _objectWithoutProperties(props, _excluded);

  var cep = useCEP('Table');
  var rtl = cep.direction === 'rtl';
  var onStateChange = useRefCallback(function (state) {
    propOnStateChange === null || propOnStateChange === void 0 ? void 0 : propOnStateChange(state);
    propOnChange === null || propOnChange === void 0 ? void 0 : propOnChange({
      filters: state.filterState,
      sorter: state.sortState,
      page: state.page,
      pageSize: state.pageSize
    });
  });
  var renderEmptyCallback = useCallback(function () {
    return renderEmpty && renderEmpty();
  }, [renderEmpty]);
  var stateRef = useRef({
    filterState: {},
    sortState: [],
    page: 1,
    pageSize: 10
  });
  var onPaginationStateChange = useConstCallback(function (_ref) {
    var page = _ref.page,
        size = _ref.size;
    onStateChange(_objectSpread(_objectSpread({}, stateRef.current), {}, {
      page: page,
      pageSize: size
    }));
  });
  var onSorterChange = useConstCallback(function (sortState) {
    onStateChange(_objectSpread(_objectSpread({}, stateRef.current), {}, {
      sortState: sortState
    }));
  });
  var onFilterChange = useConstCallback(function (filterState) {
    onStateChange(_objectSpread(_objectSpread({}, stateRef.current), {}, {
      filterState: filterState,
      page: 1
    }));
  });
  var idProp = dataPropsMapping.id || rowKey || 'id';
  var childrenProp = dataPropsMapping.children || 'children';
  var getId = useRefCallback(isFunction(idProp) && idProp || function (row, index) {
    var _a;

    return (_a = row[idProp]) !== null && _a !== void 0 ? _a : index;
  });
  var getChildren = useRefCallback(isFunction(childrenProp) && childrenProp || function (row) {
    return row[childrenProp];
  });

  var _useTableRowsInit = useTableRowsInit(data, {
    getId: getId,
    getChildren: getChildren
  }),
      _useTableRowsInit2 = _slicedToArray(_useTableRowsInit, 2),
      original = _useTableRowsInit2[0],
      rowCount = _useTableRowsInit2[1];

  var current = original;
  var treeOptions = isObject(propTreeOptions) && propTreeOptions || undefined;
  var treeEnable = isBoolean(propTreeOptions) ? propTreeOptions : undefined;

  var _useTableTreeInit = useTableTreeInit(treeOptions, current, treeEnable),
      _useTableTreeInit2 = _slicedToArray(_useTableTreeInit, 2),
      treeActive = _useTableTreeInit2[0],
      treeActions = _useTableTreeInit2[1];

  var expandOptions = useMemo(function () {
    if (isObject(propExpandOptions)) {
      return propExpandOptions;
    }

    if (renderExpand) {
      var content = function content(info) {
        var expansion = info.expansion,
            extra = _objectWithoutProperties(info, _excluded2);

        return renderExpand(info.row, _objectSpread({
          expanded: (expansion === null || expansion === void 0 ? void 0 : expansion.active) || false
        }, extra), function (value) {
          return value ? expansion === null || expansion === void 0 ? void 0 : expansion.activate() : expansion === null || expansion === void 0 ? void 0 : expansion.inactivate();
        });
      };

      if (rowExpandTrigger) {
        var expandedRows = rowExpandTrigger.expandedRows,
            onExpandedRowsChange = rowExpandTrigger.onExpandedRowsChange;
        return {
          value: expandedRows,
          onChange: onExpandedRowsChange,
          content: content
        };
      }

      return {
        value: expandedRowKeys,
        onChange: onExpandedRowChange,
        content: content
      };
    }
  }, [propExpandOptions, renderExpand]);

  var _useTableExpansionIni = useTableExpansionInit(expandOptions),
      _useTableExpansionIni2 = _slicedToArray(_useTableExpansionIni, 2),
      expansionActive = _useTableExpansionIni2[0],
      expansionActions = _useTableExpansionIni2[1];

  var selectOptions = useMemo(function () {
    if (isObject(propSelectOptions)) {
      return propSelectOptions;
    }

    if (rowSelection) {
      var columnWidth = rowSelection.columnWidth,
          columnTitle = rowSelection.columnTitle,
          fixed = rowSelection.fixed,
          align = rowSelection.align,
          valign = rowSelection.valign,
          type = rowSelection.type,
          selectedRowKeys = rowSelection.selectedRowKeys,
          _onChange = rowSelection.onChange,
          getCheckboxProps = rowSelection.getCheckboxProps;

      if (type === 'radio') {
        var singleOptions = {
          type: 'single',
          value: selectedRowKeys === null || selectedRowKeys === void 0 ? void 0 : selectedRowKeys[0],
          onChange: function onChange(newValue) {
            return _onChange === null || _onChange === void 0 ? void 0 : _onChange(newValue && [newValue] || []);
          },
          width: columnWidth,
          title: columnTitle,
          align: align,
          valign: valign,
          fixed: fixed && 'start'
        };
        return singleOptions;
      }

      var multipleOptions = {
        type: 'multiple',
        value: selectedRowKeys,
        onChange: _onChange,
        width: columnWidth,
        title: columnTitle,
        align: align,
        valign: valign,
        fixed: fixed && 'start',
        componentProps: function componentProps(info) {
          var _ref2 = (getCheckboxProps === null || getCheckboxProps === void 0 ? void 0 : getCheckboxProps(info.row)) || {},
              className = _ref2.className,
              disabled = _ref2.disabled;

          return {
            className: className,
            disabled: disabled
          };
        }
      };
      return multipleOptions;
    }

    return undefined;
  }, [propSelectOptions, rowSelection]);

  var _useTableSelectionIni = useTableSelectionInit(selectOptions),
      _useTableSelectionIni2 = _slicedToArray(_useTableSelectionIni, 3),
      selected = _useTableSelectionIni2[0],
      selectionActions = _useTableSelectionIni2[1],
      selectionColumn = _useTableSelectionIni2[2];

  var aggregatedColumns = useMemo(function () {
    return selectionColumn && [selectionColumn].concat(_toConsumableArray(propColumns)) || propColumns;
  }, [propColumns, selectionColumn]);

  var _useTableColumnsInit = useTableColumnsInit(aggregatedColumns, rtl, propColumnsOptions),
      deep = _useTableColumnsInit.deep,
      colCount = _useTableColumnsInit.colCount,
      columns = _useTableColumnsInit.columns,
      leafColumns = _useTableColumnsInit.leafColumns,
      innerColumns = _useTableColumnsInit.innerColumns,
      setInnerColumns = _useTableColumnsInit.setInnerColumns,
      resizable = _useTableColumnsInit.resizable;

  var filterOptions = useMemo(function () {
    if (isObject(propFilterOptions)) {
      var _onChange2 = propFilterOptions.onChange;
      return _objectSpread(_objectSpread({
        process: internalProcess
      }, propFilterOptions), {}, {
        onChange: function onChange(v, e) {
          _onChange2 === null || _onChange2 === void 0 ? void 0 : _onChange2(v, e);
          onFilterChange(v);
        }
      });
    }

    if (filters) {
      return {
        process: internalProcess,
        value: filters,
        onChange: onFilterChange
      };
    }

    if (propFilterOptions) {
      return {
        process: internalProcess
      };
    }

    return undefined;
  }, [internalProcess, propFilterOptions, filters]);

  var _useTableFilterInit = useTableFilterInit(current, columns, filterOptions),
      _useTableFilterInit2 = _slicedToArray(_useTableFilterInit, 3),
      filteredRows = _useTableFilterInit2[0],
      filterState = _useTableFilterInit2[1],
      filterActions = _useTableFilterInit2[2];

  current = filteredRows;
  var sortOptions = useMemo(function () {
    if (isObject(propSortOptions)) {
      var _onChange3 = propSortOptions.onChange;
      return _objectSpread(_objectSpread({
        process: internalProcess
      }, propSortOptions), {}, {
        onChange: function onChange(v, e) {
          _onChange3 === null || _onChange3 === void 0 ? void 0 : _onChange3(v, e);
          onSorterChange(v);
        }
      });
    }

    if (sorter) {
      return {
        process: internalProcess,
        value: sorter,
        onChange: onSorterChange,
        type: multipleSorter && 'multiple' || 'single',
        sortAs: multipleSorter === 'pre-selection-first' && 'push' || multipleSorter === 'post-selection-first' && 'unshift' || undefined
      };
    }

    if (propSortOptions) {
      return {
        process: internalProcess
      };
    }

    return undefined;
  }, [internalProcess, propSortOptions, sorter]);

  var _useTableSortInit = useTableSortInit(current, columns, sortOptions),
      _useTableSortInit2 = _slicedToArray(_useTableSortInit, 3),
      sortedRows = _useTableSortInit2[0],
      sortState = _useTableSortInit2[1],
      sortActions = _useTableSortInit2[2];

  current = sortedRows;
  var paginationOptions = useMemo(function () {
    if (isObject(propPaginationOptions)) {
      return _objectSpread(_objectSpread({
        process: internalProcess,
        props: _objectSpread(_objectSpread({}, propPaginationProps), propPaginationOptions.props)
      }, propPaginationOptions), {}, {
        onStateChange: onPaginationStateChange
      });
    }

    if (pager) {
      var page = pager.page,
          defaultPage = pager.defaultPage,
          pageSize = pager.pageSize,
          total = pager.total,
          _props = _objectWithoutProperties(pager, _excluded3);

      return {
        process: internalProcess,
        page: page,
        defaultPage: defaultPage,
        size: pageSize,
        total: total,
        onStateChange: onPaginationStateChange,
        props: _objectSpread(_objectSpread({}, _props), propPaginationProps)
      };
    }

    if (propPaginationOptions) {
      return {
        process: internalProcess,
        props: propPaginationProps
      };
    }

    return undefined;
  }, [internalProcess, propPaginationOptions, pager]);

  var _useTablePaginationIn = useTablePaginationInit(current, paginationOptions),
      _useTablePaginationIn2 = _slicedToArray(_useTablePaginationIn, 4),
      pagedRows = _useTablePaginationIn2[0],
      paginationState = _useTablePaginationIn2[1],
      paginationActions = _useTablePaginationIn2[2],
      paginationProps = _useTablePaginationIn2[3];

  current = pagedRows;
  current = useTableRowsPostInit(current, treeActive, treeActions, expansionActive, expansionActions, selected, selectionActions, selectOptions);
  stateRef.current = useMemo(function () {
    var _a, _b;

    return {
      filterState: filterState !== null && filterState !== void 0 ? filterState : {},
      sortState: sortState !== null && sortState !== void 0 ? sortState : [],
      page: (_a = paginationState === null || paginationState === void 0 ? void 0 : paginationState.page) !== null && _a !== void 0 ? _a : 1,
      pageSize: (_b = paginationState === null || paginationState === void 0 ? void 0 : paginationState.size) !== null && _b !== void 0 ? _b : 10
    };
  }, [filterState, sortState, paginationState]);
  return React.createElement(CepContext.Provider, {
    value: cep
  }, React.createElement(ImplementContext.Provider, {
    value: implement === 'table' && IMPLEMENT_TABLE || IMPLEMENT_DIV
  }, React.createElement(TableContextProvider, {
    rowCount: rowCount,
    original: original,
    current: current,
    deep: deep,
    colCount: colCount,
    columns: columns,
    leafColumns: leafColumns,
    treeActive: treeActive,
    treeActions: treeActions,
    expansionActive: expansionActive,
    expansionActions: expansionActions,
    selected: selected,
    selectionActions: selectionActions,
    filterState: filterState,
    filterActions: filterActions,
    sortState: sortState,
    sortActions: sortActions,
    paginationState: paginationState,
    paginationActions: paginationActions,
    emptyText: emptyText,
    renderEmpty: renderEmptyCallback,
    innerColumns: innerColumns,
    setInnerColumns: setInnerColumns,
    resizable: resizable
  }, React.createElement(TableRoot, _objectSpread(_objectSpread({}, attrs), {
    paginationProps: paginationProps
  })))));
}
TableNew.Summary = Summary;